import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'store';

import { clearUser, registrationCreated } from '../actions';

import { CandidateProductDetails, RegistrationCandidateDetails } from './types';
export interface CandidateState {
  details: RegistrationCandidateDetails | undefined;
  productDetails: Omit<CandidateProductDetails, 'examRetake'> | undefined;
}

const initialState: CandidateState = {
  details: undefined,
  productDetails: undefined,
};

export const candidateSlice = createSlice({
  name: 'candidate',
  initialState,
  reducers: {
    setCandidate: (state, { payload }: PayloadAction<RegistrationCandidateDetails>) => {
      state.details = payload;
    },
    setCandidateProductDetails: (
      state,
      { payload: { examRetake, ...productDetails } }: PayloadAction<CandidateProductDetails>
    ) => {
      state.productDetails = productDetails;
    },
  },
  extraReducers: (builder) => {
    builder
        .addCase(registrationCreated, () => initialState)
        .addCase(clearUser, () => initialState);
  },
});

export const { setCandidate, setCandidateProductDetails } = candidateSlice.actions;

export const selectCandidate = (state: RootState) => state.candidate.details;
export const selectCandidateProductDetails = (state: RootState) => state.candidate.productDetails;

export default candidateSlice.reducer;
